import ReactModel from './ReactModel';

export default class Model extends ReactModel {
    constructor(config)
    {
        super(config);

        this.environment = 'web';
    }
};